export default function Style(theme) {
    const style = {
      root: {
        padding: 0,
        margin: '10px 0',
        width: 'auto'
      },
      button: {
          margin: '5px',
          display: "inline-block",
          textDecoration: "none"
      },
    }
    return style
}